export const APP_NAME = 'product-info-dialog';
export const IDENTITY_CLIENT_ID = 'SPADev';
export const NOT_LOGGED_IN_USER_ID = -1;
export const ROOT_ELEMENT_ID = `${APP_NAME}-root`;
export const TRANSLATIONS_ENDPOINT = '/system/ajax/Localization/Translate';
